__turbopack_context__.v({
  "actions": "Navbar-module__f9Mg3q__actions",
  "badge": "Navbar-module__f9Mg3q__badge",
  "brand": "Navbar-module__f9Mg3q__brand",
  "closeBtn": "Navbar-module__f9Mg3q__closeBtn",
  "drawer": "Navbar-module__f9Mg3q__drawer",
  "drawerFooter": "Navbar-module__f9Mg3q__drawerFooter",
  "drawerFooterAward": "Navbar-module__f9Mg3q__drawerFooterAward",
  "drawerFooterAwards": "Navbar-module__f9Mg3q__drawerFooterAwards",
  "drawerFooterRating": "Navbar-module__f9Mg3q__drawerFooterRating",
  "drawerHeader": "Navbar-module__f9Mg3q__drawerHeader",
  "drawerHeaderCompact": "Navbar-module__f9Mg3q__drawerHeaderCompact",
  "drawerNav": "Navbar-module__f9Mg3q__drawerNav",
  "drawerOpen": "Navbar-module__f9Mg3q__drawerOpen",
  "drawerProfileCard": "Navbar-module__f9Mg3q__drawerProfileCard",
  "drawerProfileChevron": "Navbar-module__f9Mg3q__drawerProfileChevron",
  "drawerProfileCopy": "Navbar-module__f9Mg3q__drawerProfileCopy",
  "drawerProfileIcon": "Navbar-module__f9Mg3q__drawerProfileIcon",
  "drawerProfileSubtitle": "Navbar-module__f9Mg3q__drawerProfileSubtitle",
  "drawerProfileTitle": "Navbar-module__f9Mg3q__drawerProfileTitle",
  "flag": "Navbar-module__f9Mg3q__flag",
  "greeting": "Navbar-module__f9Mg3q__greeting",
  "iconBtn": "Navbar-module__f9Mg3q__iconBtn",
  "locale": "Navbar-module__f9Mg3q__locale",
  "localeChevron": "Navbar-module__f9Mg3q__localeChevron",
  "localeChevronOpen": "Navbar-module__f9Mg3q__localeChevronOpen",
  "localeDropdown": "Navbar-module__f9Mg3q__localeDropdown",
  "localeOption": "Navbar-module__f9Mg3q__localeOption",
  "localeWrap": "Navbar-module__f9Mg3q__localeWrap",
  "loginBtn": "Navbar-module__f9Mg3q__loginBtn",
  "logoImg": "Navbar-module__f9Mg3q__logoImg",
  "menuArrow": "Navbar-module__f9Mg3q__menuArrow",
  "menuBtn": "Navbar-module__f9Mg3q__menuBtn",
  "menuLink": "Navbar-module__f9Mg3q__menuLink",
  "menuList": "Navbar-module__f9Mg3q__menuList",
  "moduleNavDesktopWrap": "Navbar-module__f9Mg3q__moduleNavDesktopWrap",
  "navbar": "Navbar-module__f9Mg3q__navbar",
  "navbarTopRow": "Navbar-module__f9Mg3q__navbarTopRow",
  "navbarTopRowWithModules": "Navbar-module__f9Mg3q__navbarTopRowWithModules",
  "navbarVariant": "Navbar-module__f9Mg3q__navbarVariant",
  "navbarWithModules": "Navbar-module__f9Mg3q__navbarWithModules",
  "overlay": "Navbar-module__f9Mg3q__overlay",
  "overlayVisible": "Navbar-module__f9Mg3q__overlayVisible",
  "userMenuChevron": "Navbar-module__f9Mg3q__userMenuChevron",
  "userMenuChevronOpen": "Navbar-module__f9Mg3q__userMenuChevronOpen",
  "userMenuPopover": "Navbar-module__f9Mg3q__userMenuPopover",
  "userMenuTrigger": "Navbar-module__f9Mg3q__userMenuTrigger",
  "userMenuWrap": "Navbar-module__f9Mg3q__userMenuWrap",
});
